































import { Component, Vue, Prop } from 'vue-property-decorator';
import ReportAction from './ReportAction.vue';
import { vxm } from '@/store.vuex';
@Component({
  components: {
    ReportAction,
  },
})
export default class CommentAction extends Vue {
  @Prop() commentInfo;
  @Prop() postId;
  @Prop() isPostDetailsPage;
  get canShowDelete() {
    return (
      this.commentInfo.candidateInfo.candidateId ===
      vxm.users.myUserProfile.userId
    );
  }
  async deleteComment() {
    await vxm.forum.deleteComment({
      commentId: this.commentInfo.commentId,
      postId: this.postId,
    });
    vxm.forum.listComments({ postId: this.postId, initCall: true });
  }
}
